document.addEventListener('DOMContentLoaded', function() {
  if (document.querySelector('.homepage-solutions-swiper')) {
    var homepageSolutionsSwiper = new Swiper(".homepage-solutions-swiper", {
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
          var slide = this.slides[index];
          var attribute = slide.getAttribute('data-solution');
          return '<span class="' + className + ' solution-swiper-pagination">' + attribute + '</span>';
        },
      }
    });
  }

  if (document.querySelector('.homepage-recommended-swiper')) {
    var homepageRecommendedSwiper = new Swiper(".homepage-recommended-swiper", {
      slidesPerView: 1,
      spaceBetween: 60,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".homepage-recommended-swiper .swiper-button-next",
        prevEl: ".homepage-recommended-swiper .swiper-button-prev",
      }
    })

    homepageRecommendedSwiper.autoplay.stop();
    window.addEventListener('scroll', function() {
      var targetElement = document.getElementById('homepage-recommended-swiper');
      var targetPosition = targetElement.getBoundingClientRect().top;
      if (window.pageYOffset + window.innerHeight > targetPosition) {
        homepageRecommendedSwiper.autoplay.start();
      }
    });
    
  }

  
  
});